import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Dashboard from '@/components/childrens/Dashboard.vue'
import Activity from '@/components/childrens/Activity.vue'
import Business from '@/components/childrens/Business.vue'
import Catalog from '@/components/childrens/Catalog.vue'
import Category from '@/components/childrens/Category.vue'
import Collaborators from '@/components/childrens/Collaborators.vue'
import Cuts from '@/components/childrens/Cuts.vue'
import Extras from '@/components/childrens/Extras.vue'
import Orders from '@/components/childrens/Orders.vue'
import Pos from '@/components/childrens/Pos.vue'
import Stock from '@/components/childrens/Stock.vue'
import Sales from '@/components/childrens/Sales.vue'
import Help from '@/views/Help.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children: [
      {
        path: '',
        name: 'home-index',
        redirect: 'dashboard'
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard
      },
      {
        path: 'sales',
        name: 'sales',
        component: Sales
      },
      {
        path: 'activity',
        name: 'activity',
        component: Activity
      },
      {
        path: 'business',
        name: 'business',
        component: Business
      },
      {
        path: 'catalog',
        name: 'catalog',
        component: Catalog
      },
      {
        path: 'category',
        name: 'category',
        component: Category
      },
      {
        path: 'collaborators',
        name: 'collaborators',
        component: Collaborators
      },
      {
        path: 'cuts',
        name: 'cuts',
        component: Cuts
      },
      {
        path: 'extras',
        name: 'extras',
        component: Extras
      },
      {
        path: 'stock',
        name: 'stock',
        component: Stock
      },
      {
        path: 'orders',
        name: 'orders',
        component: Orders
      },
      {
        path: 'pos',
        name: 'pos',
        component: Pos
      },
      {
        path: 'help',
        name: 'help',
        component: Help
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
